import type {
  CheckoutUser,
  CheckoutUserWithAddress,
  CheckoutUserWithShippingAddress,
} from '@trmediaab/zebra-types/trhub';

export const isUserWithAddress = (
  user: Partial<CheckoutUser> | undefined,
): user is CheckoutUserWithAddress => validateAddress(user, undefined, false);

export const isUserWithShippingAddress = (
  user: Partial<CheckoutUser> | undefined,
): user is CheckoutUserWithShippingAddress =>
  validateAddress(user, undefined, true);

export default function validateAddress(
  saved: Partial<CheckoutUser> = {},
  pending: Partial<CheckoutUser> = {},
  validateShipping = false,
  requireSwedishPostalCode = false,
) {
  const merged = {
    ...saved,
    ...pending,
    address: { ...saved.address, ...pending.address },
  };
  if (
    requireSwedishPostalCode &&
    (merged.address.postalCode == null ||
      merged.address.postalCode.replace(' ', '').length < 5)
  ) {
    return false;
  }

  const requiredFields = [
    merged.firstName,
    merged.lastName,
    merged.address.address,
    merged.address.city,
    merged.address.postalCode,
  ];

  if (validateShipping) {
    requiredFields.push(merged.mobile, merged.address.country);
  }

  return requiredFields.every(s => s != null && s.length > 0);
}
